import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getPriceDictionary(params) {
  return request({
    url: '/GetPriceDictionary',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        BeefPriceKeyType: params.BeefPriceKeyType
      }
    }
  })
}

export function addPriceDictionary(params) {
  return request({
    url: '/AddPriceDictionary',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000002,
      MessageID: btcguid(),
      Data: {
        BeefPriceKey: params.BeefPriceKey,
        BeefPriceValCn: params.BeefPriceValCn,
        BeefPriceValEn: params.BeefPriceValEn,
        BeefPriceKeyType: params.BeefPriceKeyType,
        BeefPriceKeyParent: params.BeefPriceKeyParent,
        BeefPriceKeySecondParent: params.BeefPriceKeySecondParent
      }
    }
  })
}

export function updatePriceDictionary(params) {
  return request({
    url: '/UpdatePriceDictionary',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000003,
      MessageID: btcguid(),
      Data: {
        BeefPriceDictID: params.BeefPriceDictID,
        BeefPriceValCn: params.BeefPriceValCn,
        BeefPriceValEn: params.BeefPriceValEn,
        OldBeefPriceValCn: params.OldBeefPriceValCn,
        OldBeefPriceValEn: params.OldBeefPriceValEn,
        BeefPriceKeyType: params.BeefPriceKeyType
      }
    }
  })
}

export function deletePriceDictionary(params) {
  return request({
    url: '/DeletePriceDictionary',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000004,
      MessageID: btcguid(),
      Data: {
        BeefPriceDictID: params.BeefPriceDictID
      }
    }
  })
}

export function getPriceDictionaryKeys(params) {
  return request({
    url: '/GetPriceDictionaryKeys',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000005,
      MessageID: btcguid(),
      Data: {
        // BeefPriceKeyType: params.BeefPriceKeyType  GetBeefPriceDataOpinionList
      }
    }
  })
}

export function getBeefPriceDataOpinionList(params) {
  return request({
    url: '/GetBeefPriceDataOpinionList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1000006,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.KeyWord,
        HighLow: params.HighLow,
        PlantNo: params.PlantNo,
        CreateDate: params.CreateDate,
        LanguageCode: params.LanguageCode,
        FeedingMode: params.FeedingMode
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/price.js